'use client'
import { queryKeys } from '@/shared/api/react-query'
import { useQuery } from '@tanstack/react-query'
import services from '../services'
import { useGetProjectId } from '@/app/slugs'

const useQueryHook = () => {
  const { projectId } = useGetProjectId()
  const queryKey = [queryKeys((a, m, p) => a.project.getProjectMembers({ projectId }) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => {
      const res = await services.getProjectMembers({ projectId })
      if (res) return res
    },
  })

  return {
    ...query,
    queryKey,
    data: query?.data ? query.data : [],
  }
}
export default useQueryHook
